import React from 'react'
import MyTable from '../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../../../UI/table/MyTableNotFound'
import WriteOffActItemShort from './WriteOffActItemShort'

const WriteOffActItemsTableShort = ({ writeOffActItems }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">№</TableCell>
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">Кількість</TableCell>
                <TableCell align="center">Погодження</TableCell>
            </>
        }
        body={
            writeOffActItems && writeOffActItems.length > 0 ?
                writeOffActItems.map((writeOffActItem, index) => 
                    <WriteOffActItemShort
                        key={writeOffActItem.id}
                        index={index}
                        writeOffActItem={writeOffActItem} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Позицій не знайдено' 
                />
        }
        name='позицій'
        hidePagination={true}
    />
  )
}

export default WriteOffActItemsTableShort